/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
export const CertificatesEnum = {
    // Certs
    GET_CERTS: '/certificates/certs',
    POST_CERT: '/certificates/certs',
    GET_CERT: (certId: string): string => '/certificates/certs/' + certId,
    PUT_CERT: (certId: string): string => '/certificates/certs/' + certId,
    DELETE_CERT: (certId: string): string => '/certificates/certs/' + certId,
    // CSRs
    GET_SIG_ALGORITHMS: '/certificates/signature-algorithm',
    GET_CSRS: '/certificates/csrs',
    GET_CSR: (csrId: string): string => '/certificates/csrs/' + csrId,
    POST_CSR: '/certificates/csrs',
    PUT_APPLY_CSR: (csrId: string): string => '/certificates/csrs/' + csrId + '/apply',
    PUT_CSR: (csrId: string): string => '/certificates/csrs/' + csrId,
    DELETE_CSR: (csrId: string): string => '/certificates/csrs/' + csrId,
    PUT_SELF_CERT_RENEW: (csrId: string): string => `/certificates/csrs/${csrId}/renew`,
    GET_CAS: '/certificates/cas',
    GET_CA: (caId: string): string => '/certificates/cas/' + caId,
    POST_CA: '/certificates/cas',
    PUT_CA: (caId: string): string => '/certificates/cas/' + caId,
    DELETE_CA: (caId: string): string => '/certificates/cas/' + caId,
    GET_CRLS: '/certificates/crls',
    POST_CRL: '/certificates/crls',
    GET_CRL: (crlId: string): string => '/certificates/crls/' + crlId,
    PUT_CRL: (crlId: string): string => '/certificates/crls/' + crlId,
    DELETE_CRL: (crlId: string): string => '/certificates/crls/' + crlId,
};
